import { createClient } from "@lib/supabase/client";
import type { ProfileData } from "@/types/profile";

const PROFILE_SELECT =
  "full_name, phone_number, phone_number_verified, phone_number_verified_at, avatar_url, preferred_role, onboarding_completed_at, country_code, gender, bio, updated_at, deletion_requested_at";

export async function fetchProfileData(
  timeoutMs?: number,
): Promise<ProfileData | null> {
  const supabase = createClient();
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  try {
    const fetchPromise = supabase
      .from("users")
      .select(PROFILE_SELECT)
      .maybeSingle();

    let result;
    if (timeoutMs) {
      const timeoutPromise = new Promise<never>((_, reject) => {
        timeoutId = setTimeout(
          () => reject(new Error("Profile fetch timeout")),
          timeoutMs,
        );
      });
      result = await Promise.race([fetchPromise, timeoutPromise]);
      if (timeoutId) clearTimeout(timeoutId);
    } else {
      result = await fetchPromise;
    }

    const { data: userData, error } = result as {
      data: ProfileData | null;
      error: { message?: string } | null;
    };

    if (error) {
      console.error("[fetchProfileData]", error);
      return null;
    }

    // No row is "unknown", not an empty profile: callers must not treat absence
    // as an incomplete onboarding state.
    return userData;
  } catch (error) {
    if (timeoutId) clearTimeout(timeoutId);
    console.warn("[fetchProfileData]", error);
    return null;
  }
}
